import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import admin from './modules/admin'
import adverts from './modules/adverts'
import arena from './modules/arena'
import bidCards from './modules/bid-cards'
import bidSessions from './modules/bid-sessions'
import resources from './modules/resources'
import stat from './modules/stat'
import surveys from './modules/surveys'
import user from './modules/user'

Vue.use(Vuex)

export const STORAGE_KEY = 'melostock'

const store = new Vuex.Store({
  strict: true,
  modules: {
    admin,
    adverts,
    arena,
    bidCards,
    bidSessions,
    resources,
    stat,
    surveys,
    user
  },
  plugins: [createPersistedState({
    key: STORAGE_KEY,
    storage: window.sessionStorage
  })]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js